import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/products',
    name: 'PUT_PRODUCT',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
